

















































































import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import {
    Option,
    CardIndex
} from '@/entities/conversation'
import { isSafeKey } from '@/utils/string'
import FlowJumpEditor from './FlowJumpEditor.vue'
import BadgePicker from '@/pages/conversation/components/BadgePicker.vue'
import BaseTooltip from '@/components/BaseTooltip.vue'

/*
    key / value editor for each Option in Options
    emits 'change' and 'remove'
*/

@Component<OptionEditor>({
    components: {
        BaseTooltip,
        BadgePicker,
        FlowJumpEditor
    }
})
export default class OptionEditor extends Vue {
    @Getter public $companyVars
    @Prop(Object) public option!: Option
    @Prop(Boolean) public fixed?: boolean // if true, can't add or remove options, or edit their keys
    @Prop(Boolean) public disableFlowJumpEditor?: boolean
    @Prop(Boolean) public canEditKey!: boolean
    @Prop(Boolean) public linkToScorecard!: boolean
    // todo keep in scorecard v3
    @Prop({type: String, default: ''}) public scorecardTab!: string
    @Prop(Object) public cardIndex!: CardIndex
    @Prop(Boolean) public invalid!: boolean
    @Prop(Boolean) public keyFocused!: boolean
    @Prop(Boolean) public valueFocused!: boolean

    @Getter public getHasFlows!: boolean
    @Getter public getLastSave!: number

    public mounted() {
        // set the original key so when changed we can update in the backend
        this.option.ogKey = this.option.key
    }

    @Watch('getLastSave')
    public watchGetLastSave() {
      this.option.ogKey = this.option.key
    }

    public copyValueToKey() {
        this.$emit('change', {
            ...this.option,
            key: this.option.value
        })
    }

    public remove() {
        if (!this.$companyVars.has_remove_scorecard_v3_topics && this.option.scorecardTopicName) {
            return // scorecard topic can't be removed unless we turn that option on for a tenant
        }
        this.$emit('remove', this.option)
    }

    public updateKey(event: Event) {
        const value = (event.target as HTMLInputElement).value
        this.$emit('change', {
            ...this.option,
            key: value,
            badgeId: (this.scorecardTab === 'promoter' ? this.option.badgeId : value) || ''
        } as Option)
    }

    // Also make the key the same as the value if it's not editable
    public updateValue(event: Event) {
        const value = (event.target as HTMLInputElement).value
        const patch = {
            ...this.option,
            value
        }
        // when changing badge, we don't want key to change with value
        if (!this.fixed && !this.canEditKey && !this.linkToScorecard) {
            patch.key = value
        }
        this.$emit('change', patch as Option)
    }

    public updateJump(jump: string) {
        this.$emit('change', {
            ...this.option,
            jump
        } as Option)
    }

    public updateBadgeId(badgeId: string) {
        this.$emit('change', {
            ...this.option,
            badgeId
        } as Option)
    }

    public toggleScorecardCheckbox() {
        const badgeId = this.option.badgeId ? '' : this.option.key
        this.$emit('change', {
            ...this.option,
            badgeId
        } as Option)
    }

    public removeJump() {
        let newOption = { ...this.option }
        delete newOption.jump
        this.$emit('change', newOption as Option)
    }

    public onValueFocus(evt: Event) {
        (evt.target as HTMLInputElement).select()
        this.$emit('focus', 'value')
    }

    public onKeyFocus(evt: Event) {
        (evt.target as HTMLInputElement).select()
        this.$emit('focus', 'key')
    }

    public onKeyDown(evt) {
        if (!isSafeKey(evt.key)) {
            evt.preventDefault();
        }
    }
}
